import { render, staticRenderFns } from "./ImageUpload.vue?vue&type=template&id=4c44ff06&scoped=true&lang=html&"
import script from "./ImageUpload.vue?vue&type=script&lang=js&"
export * from "./ImageUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c44ff06",
  null
  
)

export default component.exports